import React from "react";
import AntTable from "components/UI/AntTable";
import DashedTooltip from "components/UI/DashedTooltip";

// Fill quality of AutoTrader orders (backend api/broker-orders/fill-quality.js).
// Positive = worse for us: paid more on a buy / got less on a sell.
export const formatSlippage = (value) => {
  if (value === null || value === undefined) return "-";
  return (
    <span className={value > 0 ? "red" : value < 0 ? "green" : ""}>
      {value.toFixed(2)}%
    </span>
  );
};

export const VS_MID_TIP =
  "Fill vs the bid/ask mid when the order was placed: how well the execution (own algo / IB Adaptive) did. Positive = paid more on a buy / got less on a sell.";
export const VS_ADVISED_TIP =
  "Fill vs the strategy's price (stock: buy point / sell signal price; option: 15:50 ask / exit mid): the real slippage. Positive = worse.";

const sortNumber = (key) => (a, b) => (a[key] ?? -Infinity) - (b[key] ?? -Infinity);

const FillQualityTable = ({ data, showOwner = false }) => {
  const columns = [
    ...(showOwner ? [{ title: "User", dataIndex: "owner" }] : []),
    { title: "Type", dataIndex: "tradeType" },
    {
      title: "Side",
      dataIndex: "side",
      render: (side) => (
        <span className={side === "buy" ? "green" : "red"}>{side}</span>
      ),
    },
    { title: "Algo", dataIndex: "algo" },
    { title: "Urgency", dataIndex: "urgency" },
    { title: "Orders", dataIndex: "orders", sorter: sortNumber("orders") },
    {
      title: <DashedTooltip text={VS_MID_TIP}>Vs mid</DashedTooltip>,
      dataIndex: "vsMid",
      render: formatSlippage,
      sorter: sortNumber("vsMid"),
    },
    {
      title: <DashedTooltip text={VS_ADVISED_TIP}>Vs advised</DashedTooltip>,
      dataIndex: "vsAdvised",
      render: formatSlippage,
      sorter: sortNumber("vsAdvised"),
    },
    {
      title: "Avg spread",
      dataIndex: "spread",
      render: (value) => (value === null ? "-" : `${value.toFixed(2)}%`),
      sorter: sortNumber("spread"),
    },
  ];
  const rows = (data?.groups || []).map((row) => ({
    ...row,
    key: [row.owner, row.tradeType, row.side, row.algo, row.urgency].join("|"),
  }));
  return <AntTable rowKey="key" dataSource={rows} columns={columns} virtual={false} />;
};

export default FillQualityTable;
